<template>
  <v-dialog
      class="hide-on-print"
      persistent
      v-model="innerOpen"
      width="1000">

    <v-card class="hide-on-print">
      <v-toolbar color="blue darken-3" dark>
        <v-toolbar-title>Edit Visa Request</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-form class="pt-2 mx-2" lazy-validation ref="manualRef">
          <v-layout class="mt-2" row wrap>
            <v-flex xs4>
              <v-text-field
                  outlined
                  label="Total days"
                  @focus="focusOnDays"
                  @blur="focusOnDaysData = false"
                  v-model="total_days"
              ></v-text-field>
            </v-flex>
            <v-flex xs4 class="pl-2"
                    v-if="customEditCost">
              <v-text-field
                  outlined
                  label="Visa fee"
                  v-model="visa_fee"
              ></v-text-field>
            </v-flex>
            <v-flex xs4 class="pl-2"
                    v-if="customEditCost">
              <v-text-field
                  outlined
                  label="Late fee"
                  v-model="late_fee"
              ></v-text-field>
            </v-flex>
            <v-flex xs4 class="pl-2" v-if="!customEditCost">
              <v-alert outlined type="info">
                Visa Fee: $<b>{{ cost }}</b>
              </v-alert>
            </v-flex>
            <v-flex xs4 class="pl-2" v-if="!customEditCost">
              <v-alert outlined type="info">
                Late Fee:
                ${{
                  visaRequest.payment_info ? visaRequest.payment_info.late_stay_cost : visaRequest.payment_detail.late_stay_cost
                }}
              </v-alert>
            </v-flex>
            <v-flex xs12 class="pl-2" v-if="!customEditCost">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-radio-group row v-model="visa_plan">
                    <v-radio :value="1" label="Apply with Plain" :readonly="checkConditionPlan"
                             v-if="viewData.show_sre"/>
                    <v-radio :value="2" label="Apply with SRE (Single Re-entry)" :readonly="checkConditionPlan"
                             v-if="visaRequest.visa_type_slug  !== 'tourist-visa'"/>
                    <v-radio :value="3" label="Apply with MRE (Multiple Re-entry)" :readonly="checkConditionPlan"
                             v-if="viewData.show_mre"/>
                  </v-radio-group>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex class="pl-3 mt-2 pr-5" xs6>
              <new-date-picker
                  :readonly="visaRequest.submission_no.substr(0, 1) === 'E'"
                  :maxYear="getYearPreviousOrAfterCurrent(1)"
                  :min="2000"
                  label="Visa Start Date"
                  :watch-value="true"
                  v-model="start_date"
              />
            </v-flex>
            <v-flex class="mt-2 pr-3 pl-5" xs6>
              <new-date-picker
                  :maxYear="getYearPreviousOrAfterCurrent(10)"
                  :min="2000"
                  :watch-value="true"
                  label="Visa End Date"
                  v-model="end_date"
              />
            </v-flex>
            <v-flex xs12 v-if="showFormEdit && !visaRequest.verified">
              <component v-bind:is="visa_type_slug" :for-processing="true"/>
            </v-flex>
          </v-layout>
        </v-form>

      </v-card-text>
      <v-divider style="margin-top:31px;"/>
      <v-card-actions>
        <v-spacer/>
        <v-btn
            @click="cancel"
            class="white--text"
            color="red darken-3"
        >Cancel
        </v-btn>
        <v-btn
            @click="save"
            class="white--text"
            color="blue darken-3"
        >Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {validationMixin} from "../../mixins/validationMixin";
import {commonListMixin} from "../../mixins/commonListMixin";
import {VERSIONED_API_URL} from "../../config/config";
import Http from "axios"
import {mapGetters} from "vuex";
import NewDatePicker from "../NewDatePicker";
import moment from "moment"

import TouristVisa from "../visa/form/TouristVisa";
import RelationVisa from "../visa/form/RelationVisa";
import StudyVisa from "../visa/form/StudyVisa";
import MarriageVisa from "../visa/form/MarriageVisa";
import BusinessVisa from "../visa-types/confirm/BusinessVisa";
import ResidentialVisa from "../visa/form/ResidentialVisa";
import WorkingVisa from "../visa/form/WorkingVisa";
import PressVisa from "../visa/form/PressVisa";
import ConfirmationHeaderText from "../ConfirmationHeaderText";
import NRNVisa from '../visa/form/NRNVisa'

export default {
  name: "ManualPaymentDialog",
  components: {
    ConfirmationHeaderText,
    NewDatePicker,
    TouristVisa,
    RelationVisa,
    'nrn-visa': NRNVisa,
    StudyVisa,
    MarriageVisa,
    BusinessVisa,
    ResidentialVisa,
    'working-visa': WorkingVisa,
    PressVisa
  },
  props: ['value', 'url'],
  mixins: [commonListMixin, validationMixin],
  data() {
    return {
      paymentData: {},
      innerOpen: false,
      start_date: null,
      end_date: null,
      total_days: null,
      focusOnDaysData: false,
      visa_plan: null,
      visa_fee: 0,
      late_fee: 0
    }
  },
  watch: {
    value(input) {
      this.innerOpen = input;
    },
    innerOpen(value) {
    },
    start_date() {
      this.end_date = moment(this.start_date).add((this.total_days - 1), 'days').format('YYYY-MM-DD')
    },
    end_date() {
      if (!this.focusOnDaysData) {
        this.calculateTotalDays()
      }
    },
    total_days() {
      if (this.focusOnDaysData) {
        this.end_date = moment(this.start_date).add((this.total_days - 1), 'days').format('YYYY-MM-DD')
      }
    }
  },
  computed: {
    ...mapGetters("VisaRequestSingle", ["visaRequest"]),
    visa_type_slug() {
      return this.visaRequest.visa_type_condition.visa_type.slug;
    },
    showFormEdit() {
      if (this.visaRequest.dependent_visa && this.visaRequest.dependent_visa.id) {
        return false;
      }
      return this.visa_type_slug !== 'tourist-visa'
    },
    customEditCost() {
      return (this.visaRequest.overstay_processing && this.$oauth.checkIfHasPermission('process overstay')) || (this.visaRequest.submission_no.substr(0, 1) === "P") || this.visaRequest.extra.apply_type === 'entry';
    },
    cost() {
      const {overstay_processing, visa_type_condition, payment_info, payment_detail} = this.visaRequest;
      const days_cost = visa_type_condition.days_cost;
      const days = this.total_days;
      let cost = 0;
      let selected_day = [];


      let substr_string = this.visaRequest.submission_no.substr(0, 1);

      if (this.customEditCost) {
        cost = payment_info ? payment_info.visa_amount : payment_detail.amount;
      } else {
        if (substr_string === "V") {
          selected_day = days_cost[0];
          cost = selected_day.cost;
        } else {
          for (let i = 0; i < days_cost.length; i++) {
            if (parseInt(days_cost[i].days) >= days) {
              if (this.visaRequest.dependent_visa && this.visaRequest.dependent_visa.id !== undefined) {
                cost = days_cost[i].cost;
              } else {
                cost = days_cost[i].cost;
              }
              selected_day = days_cost[i];
              break;
            }
          }
        }
      }


      if (cost === 0) {
        return '0';
      }
      if (payment_info !== undefined) {
        cost = parseFloat(payment_info.late_stay_cost) + parseFloat(cost);
      }

      if (payment_detail !== undefined) {
        cost = parseFloat(payment_detail.late_stay_cost) + parseFloat(cost);
      }


      selected_day.plan = parseInt(selected_day.plan);
      if (this.visa_plan > selected_day.plan) {
      if (cost != 0) {
        if (this.visa_plan === 2) {
          cost = cost + this.visaRequest.sre_cost;
        }
        if (this.visa_plan === 3) {
          cost = cost + this.visaRequest.mre_cost;
        }
      }
      }
      return cost;
    },
    viewData() {
      let show_sre = true;
      let show_mre = true;


      return {
        show_sre,
        show_mre
      }
    },
    checkConditionPlan(){
      const {visa_type_condition} = this.visaRequest;
      const days_cost = visa_type_condition.days_cost;
      for (let i = 0; i < days_cost.length; i++) {
        if (parseInt(days_cost[i].plan) === 3) {
          return true;
        }
      }
      return false;
    }
  },
  async mounted() {
    if (this.visaRequest) {
      console.log(this.visaRequest)
      if (this.visaRequest.start_date === null) {
        this.start_date = new Date().toISOString().substr(0, 10);
      } else {
        this.start_date = this.visaRequest.start_date;
      }
      this.end_date = moment(this.visaRequest.end_date).subtract('1', 'days').format('YYYY-MM-DD');
      this.visa_plan = parseInt(this.visaRequest.visa_plan);
      this.calculateTotalDays()
    }
  },
  methods: {
    focusOnDays() {
      this.focusOnDaysData = true;
    },
    async save() {
      if (this.$refs.manualRef.validate()) {
        const end_date = moment(this.end_date).format('YYYY-MM-DD');
        if (this.visaRequest.submission_no.substr(0, 1) === 'C' && this.start_date > moment(this.visaRequest.previous_visa.expiry_date).add(1,'days').format('Y-MM-DD')){
          this.$store.commit('Notification/showError', 'You cannot apply. Your start date is greater than his/her current visa expiry date')
          return
        }
        try {
          const visa_type_slug = this.visaRequest.visa_type_slug;

          let form_data = {
            start_date: this.start_date,
            end_date,
            visa_type_slug,
          };
          Object.keys(this.visaRequest.extra).forEach(key => {
            let data = JSON.parse(JSON.stringify(this.visaRequest.extra[key]));
            if (typeof data !== "object") {
              form_data[key] = data;
            } else {
              if (data !== null) {
                Object.keys(data).forEach(second_key => {
                  form_data[second_key] = data[second_key]
                })
              }
            }
          });
          if (this.visaRequest.submission_no.substr(0, 1) === "P") {
            form_data.cost = this.visa_fee;
          } else if (this.visaRequest.overstay_processing || this.visaRequest.extra.apply_type === 'entry') {
            form_data.cost = this.visa_fee
            form_data.late_stay_cost = this.late_fee;
          } else {
            form_data.cost = this.cost - (this.visaRequest.payment_info ? this.visaRequest.payment_info.late_stay_cost : this.visaRequest.payment_detail.late_stay_cost);
            form_data.late_stay_cost = this.visaRequest.payment_info ? this.visaRequest.payment_info.late_stay_cost : this.visaRequest.payment_detail.late_stay_cost;
          }
          form_data.days = this.total_days
          form_data.visa_plan = this.visa_plan

          const response = await Http.post(`${VERSIONED_API_URL}/visa-requests/modify-request/` + this.visaRequest.submission_no, form_data);
          this.$store.commit('Notification/showSuccess', response.data.message);
          this.$store.dispatch('VisaRequestSingle/getVisaRequestDetail', this.visaRequest.submission_no);
          this.cancel();
        } catch (e) {
          this.$store.commit('Notification/showError', 'Something went wrong')
        }
      }
    },
    calculateTotalDays() {

      const start_date = moment(this.start_date);
      const end_date = moment(this.end_date);
      const date_diff = end_date.diff(start_date, 'days');
      this.total_days = (date_diff + 1);
      if (this.visaRequest.overstay_processing && this.$oauth.checkIfHasPermission('process overstay')) {
        this.visa_fee = this.visaRequest.payment_info ? this.visaRequest.payment_info.visa_amount : this.visaRequest.payment_detail.amount
        this.late_fee = this.visaRequest.payment_info ? this.visaRequest.payment_info.late_stay_cost : this.visaRequest.payment_detail.late_stay_cost
      } else if (this.visaRequest.submission_no.substring(0, 1) === "P") {
        this.visa_fee = this.visaRequest.payment_info ? this.visaRequest.payment_info.total : this.visaRequest.payment_detail.amount
        this.late_fee = 0;
      }
    },
    cancel() {
      this.paymentData = {};
      this.innerOpen = false;
      this.$emit('input', false)
    }
  }
}
</script>

